import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const FAQS = [{
  q: 'Is X2PIC affiliated with X / Twitter?',
  a: 'No. X2PIC is an independent, unofficial project. It is not affiliated with, endorsed by, or sponsored by X Corp. “X”, “Twitter”, the X logo and the Twitter bird are trademarks of X Corp.'
}, {
  q: 'Does it send my screenshots anywhere?',
  a: 'Never. X2PIC has no server, account, analytics, or telemetry. Every screenshot is created and kept on your own device, and is discarded when you close the result dialog.'
}, {
  q: 'Can it capture posts taller than my screen?',
  a: 'Yes. Long posts are automatically scrolled and stitched into a single image. Captures that exceed the maximum PNG dimensions are downscaled to fit while staying in one file.'
}, {
  q: 'Can I capture replies too?',
  a: 'Yes. Select the main post plus any specific replies you want, and X2PIC exports them together as one stitched PNG.'
}, {
  q: 'Which sites does it work on?',
  a: 'X2PIC only works on x.com and twitter.com. It does not request access to any other website.'
}, {
  q: 'How much does it cost?',
  a: 'X2PIC is free. Install it from the Chrome Web Store and start capturing right away.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="w-full scroll-mt-16 bg-slate-50 py-20 sm:py-24" data-id="element-15">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-16">
        <div className="text-center" data-id="element-17">
          <h2 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-id="element-18">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-10 space-y-3" data-id="element-19">
          {FAQS.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q} className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-20">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" aria-expanded={isOpen} data-id="element-21">
                  <span className="text-base font-semibold text-slate-900" data-id="element-22">
                    {item.q}
                  </span>
                  <ExpandMoreIcon className={`shrink-0 text-slate-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-23" />
                </button>
                <AnimatePresence initial={false} data-id="element-24">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} className="overflow-hidden" data-id="element-25">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-slate-600" data-id="element-26">
                        {item.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}